module.exports = __webpack_public_path__ + "static/img/HY-S4.6c8e862b.png";